module.exports = __webpack_public_path__ + "img/p1.022f0d36.png";